import { Flex, Modal, X } from "@cisco/spaces-dash-lib-styleguide";

interface LoginModalProps {
  children?: any;
  isOpen?: boolean;
  closeModal?: () => void;
}

export function LoginModal(props: LoginModalProps): JSX.Element {
  const { children, isOpen, closeModal } = props;

  return (
    <Modal isOpen={isOpen} size="lg">
      <Flex justify="flex-end" style={{ marginBottom: "16px" }}>
        <X size={16} weight="bold" onClick={closeModal} style={{ cursor: "pointer" }} />
      </Flex>

      <div>{children}</div>
    </Modal>
  );
}
